import "core-js/stable";
import "regenerator-runtime/runtime";
import 'isomorphic-unfetch'

import Vue from 'vue'
import TheHeader from './components/v1/header/TheHeader'
// import { router } from './router/router'
import store from './store'
import { config } from './config/config'

// Apollo
import VueApollo from 'vue-apollo'
import {apolloApiClient, apolloClient} from './config/apollo'
const apolloProvider = new VueApollo({
  clients: {
    default: apolloClient,
    apiClient: apolloApiClient
  },
  defaultClient: apolloClient,
})
Vue.use(VueApollo)
// Apollo

// moment
import moment from 'vue-moment'
Vue.use(moment)
// moment

// google analytics
import VueGtag from "vue-gtag";
Vue.use(VueGtag, {
  config: {
    id: config.google_analytics_id,
    params: {
      send_page_view: false
    }
  }
});

document.addEventListener('DOMContentLoaded', () => {
  new Vue({
    el: '#vue-header',
    // router,
    apolloProvider,
    store,
    render: h => h(TheHeader)
  })
})
